import { PriceQuote } from '../interfaces/tokenPriceInfo'

const BASE_URL = 'https://api.phantom.app'

interface PriceResponse {
  history: { unixTime: number; value: string }[]
}

class PhantomDefiClient {
  private static async request<T>(url: string, params: URLSearchParams = new URLSearchParams()) {
    const result = await fetch(`${BASE_URL}/${url}?${params.toString()}`)

    if (!result.ok) {
      const errorText = (await result.text()) || 'Phantom defi fetch error'
      throw new Error(`HTTP ${result.status} error - ${errorText}`)
    }

    return result.json() as Promise<T>
  }

  static async getPriceHistory(token: string, dateRange: string): Promise<PriceQuote[]> {
    let params = new URLSearchParams()
    params.append('token', token)
    params.append('type', dateRange)
    const response: PriceResponse = await this.request('price-history/v1/', params)

    return response.history.map(({ unixTime, value }) => ({
      timestamp: unixTime,
      price: parseFloat(value),
    }))
  }
}

export default PhantomDefiClient
